import { render, staticRenderFns } from "./MarketingEmailEditSend.vue?vue&type=template&id=030bb34a&scoped=true"
import script from "./MarketingEmailEditSend.vue?vue&type=script&lang=js"
export * from "./MarketingEmailEditSend.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailEditSend.vue?vue&type=style&index=0&id=030bb34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bb34a",
  null
  
)

export default component.exports